import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as ForkIcon4 } from "../../assets/icons/Fork4.svg";
import { ReactComponent as ForkIcon3 } from "../../assets/icons/Fork3.svg";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
const DataAnalyticsInfo = () => {
  const block1 = [
    {
      title: "Installs & Reinstalls",
      description:
        " Clearly see the success of acquisition channels and campaigns.",
    },

    {
      title: "Reactivations",
      description: "Accurately measure efforts to re-engage inactive users.",
    },

    {
      title: "App Opens",
      description: "Understand how often and when users are active.",
    },

    {
      title: "Link Views",
      description:
        "Track exactly how users interact with deep links, from click to content.",
    },
  ];
  const block2 = [
    {
      title: "Deep Linking",
      description:
        "Precisely track which campaigns bring users directly into your app.",
    },

    {
      title: "Deferred Linking",
      description:
        "Maintain context from click to post-install engagement, ensuring accurate attribution.",
    },

    {
      title: "Editable Links",
      description:
        " Update links dynamically to optimize campaigns and measure changes instantly.",
    },
  ];
  const block3 = [
    {
      title: "Unified Dashboard",
      description:
        "One clear, comprehensive view of performance across all campaigns and platforms.",
    },

    {
      title: "Easy Data Exports",
      description:
        "Seamlessly export detailed campaign data via CSV or API for deeper analysis.",
    },

    {
      title: "Flexible Filtering",
      description:
        "Quickly segment and compare performance by campaign, platform, or timeframe.",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"dataAnalyticsInfo"}>
        <Content>
          <TextWrapper>
            <Title>Accurate Campaign Data—Without Complexity</Title>
            <Subtitle>
              Grovs simplifies the data you rely on every day, delivering
              precise tracking of the essential events your team needs. It gives
              your analytics team the key data points required to clearly
              measure growth—without excessive complexity or redundant
              information.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon4 color="rgba(25, 34, 74, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Clear Visibility Into User Journeys</Title>
            <Subtitle>
              Grovs' smart links provide reliable insights into user flows,
              eliminating guesswork and clearly mapping journeys. Make informed
              decisions with complete visibility into user experiences.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3 color="rgba(25, 34, 74, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Streamlined Reporting & Actionable Insights</Title>
            <Subtitle>
              Grovs ensures your team spends less time managing data and more
              time deriving insights. Access the exact data your team needs,
              quickly and efficiently.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3 color="rgba(25, 34, 74, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {block3.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default DataAnalyticsInfo;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
